import marketingPopups from '@/js/components/view/marketingPopups/marketingPopups.vue'

const alertMarketing = (payload) => {
    const MarketingConstructor = Vue.extend(marketingPopups)
    let alertDom = new MarketingConstructor({
        propsData: payload,
        i18n: window.i18n,
        el: document.createElement('div'), //将Alert组件挂载到新创建的div上
    })
    document.querySelectorAll('.extend-alert-marketing')?.[0]?.appendChild(alertDom.$el)
}

const popup = (appear, payload) => {
    let { type, value } = appear;
    if (type == 'now') {
        alertMarketing(payload);
    } else if (type == 'delay' && !isNaN(value)) {
        setTimeout(() => {
            alertMarketing(payload);
        }, value * 1000);
    } else if (type == 'out') {
        let on = true;
        $(window).on("mouseout", e => {
            if (!e.toElement && !e.relatedTarget && on) {
                on = false;
                alertMarketing(payload);
            }
        });
    }
}


;(
    async () => {
        try {
            let res = await window.axios.get('/api/store/popups?filter[status]=true&page_size=3&sort=-top_date_gmt,-created_at_gmt');
            let popupConfig = res.data.data;
            // let popupConfig = JSON.parse(marketingIndex.attr('popupconfig'));
            if (popupConfig && popupConfig.length) {

                let marketingIndex = $('#marketingIndex');
                let productId = marketingIndex.attr('productId');
                let categoryId = marketingIndex.attr('categoryId');
                let pageId = marketingIndex.attr('pageId');
                let policyId = marketingIndex.attr('policyId');

                let cachePopus = localStorage.getItem('cachePopus');

                cachePopus = cachePopus ? JSON.parse(cachePopus) : '';
                let nowTime = new Date().getTime();
                let pathname = window.location.pathname;
                popupConfig.sort(function (a, b) {
                    return new Date(a.top_date_gmt.replace(/-/g, "/")).getTime() - new Date(b.top_date_gmt.replace(/-/g, "/")).getTime();
                })
                popupConfig.forEach(item => {
                    if (!item.status) return false;
                    let { appear_page } = item.config;
                    let onOff = false;
                    if (appear_page && appear_page.length) {
                        appear_page.some(subItem => {
                            switch (subItem.target) {
                                case 'all_page':
                                    onOff = true;
                                    return true;
                                case 'is_home':
                                    if (pathname == '/') {
                                        onOff = true;
                                        return true;
                                    }
                                    break
                                case 'is_search':
                                    if (pathname == '/search') {
                                        onOff = true;
                                        return true;
                                    }
                                    break
                                case 'all_collections':
                                    if (pathname == '/collections') {
                                        onOff = true;
                                        return true;
                                    }
                                    break
                                case 'product_selected':
                                    if (productId && subItem.selected && subItem.selected.length) {
                                        onOff = subItem.selected.includes(productId - 0)
                                        return true;
                                    }
                                    break
                                case 'collection_selected':
                                    if (categoryId && subItem.selected && subItem.selected.length) {
                                        onOff = subItem.selected.includes(categoryId - 0)
                                        return true;
                                    }
                                    break
                                case 'page_selected':
                                    if (pageId && subItem.selected && subItem.selected.length) {
                                        onOff = subItem.selected.includes(pageId - 0)
                                        return true;
                                    }
                                    break
                                case 'is_policy':
                                    if (policyId && subItem.selected && subItem.selected.length) {
                                        onOff = subItem.selected.includes(policyId - 0)
                                        return true;
                                    }
                                    break
                                default:
                                    break;
                            }
                        })
                    }

                    if (onOff) {
                        let { id } = item;
                        let { title, title_color, layout, content, content_color, button_content, button_color, footer_content, background_image, interactive_settings, appear, appear_again_subscribe, appear_again_close, social_account } = item.config;
                        let payload = { id, title, title_color, layout, content, content_color, button_content, button_color, footer_content, background_image, interactive_settings, social_account }
                        // alertMarketing(payload);
                        if (cachePopus && cachePopus.length) {
                            let subOnOff = cachePopus.some(cacheItem => {
                                // 只要缓存中有找到相同id，无论是否再弹出都可以跳过这个循环；
                                if (cacheItem.id && cacheItem.id == item.id) {
                                    let subTime = !isNaN(cacheItem.subTime) ? cacheItem.subTime : 2;
                                    let closeTime = !isNaN(cacheItem.closeTime) ? cacheItem.closeTime : 1;
                                    //以订阅时间优先，关闭时间想要生效的时候必须没有订阅过，只要订阅过则只受订阅规则影响
                                    if ((appear_again_subscribe.type == 'every' && subTime > 2)
                                        || (appear_again_close.type == 'every' && closeTime > 1 && subTime == 2)
                                        || (appear_again_subscribe.type == 'delay' && (nowTime > cacheItem.subTime + appear_again_subscribe.value * 1000))
                                        || (appear_again_close.type == 'delay' && (nowTime > cacheItem.closeTime + appear_again_close.value * 1000) && subTime == 2)
                                    ) {
                                        popup(appear, payload)
                                    }
                                    // if ((appear_again_subscribe.type == 'every' && appear_again_close.type == 'every') || (appear_again_close.type == 'every' && closeTime > 1) || (appear_again_subscribe.type == 'every' && subTime > 2)) {
                                    //     popup(appear, payload)
                                    // } else if ((subTime > closeTime) && appear_again_subscribe && (!isNaN(appear_again_subscribe.value) && (nowTime > cacheItem.subTime + appear_again_subscribe.value * 1000))) {
                                    //     popup(appear, payload)
                                    // } else if (appear_again_close && (!isNaN(appear_again_close.value) && (nowTime > cacheItem.closeTime + appear_again_close.value * 1000))) {
                                    //     popup(appear, payload)
                                    // }
                                    return true;
                                }
                            })
                            //跳过这个循环
                            if (subOnOff) return false;
                        }
                        popup(appear, payload)
                    }
                })
            }
        } catch (error) {
        }
    }
)()
